import { kraben } from '../card/kraben';

export function KrabenMark({ size = 72, style }: { size?: number; style?: React.CSSProperties }) {
  return <div style={style} dangerouslySetInnerHTML={{ __html: kraben(size) }} />;
}
